import { SEO } from '../components/SEO';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Terms and Conditions - SpinEmerge',
  description: 'Terms and conditions for using SpinEmerge.com'
};

export const Terms = () => {
  return (
    <>
      <SEO
        title="Terms and Conditions - SpinEmerge"
        description="Read our terms and conditions for using SpinEmerge.com. Understand your rights and responsibilities when using our casino review platform."
        canonical="/terms"
        jsonLd={jsonLd}
      />

      <div className="min-h-screen pt-20 pb-20">
        <section className="py-12 bg-gradient-to-br from-dark-900 via-dark-800 to-dark-900">
          <div className="container mx-auto px-4 max-w-4xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white">Terms and Conditions</h1>
            <p className="text-gray-400 mb-8">Last updated: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

            <div className="space-y-8 text-gray-300">
              <section className="bg-dark-800 rounded-xl p-6 border border-gray-700">
                <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
                <p className="leading-relaxed">
                  By accessing and using SpinEmerge.com, you accept and agree to be bound by these Terms and Conditions. 
                  If you do not agree with any part of these terms, you must not use our website.
                </p>
              </section>

              <section className="bg-dark-800 rounded-xl p-6 border border-gray-700">
                <h2 className="text-2xl font-bold text-white mb-4">2. Use of Website</h2>
                <p className="leading-relaxed mb-4">
                  You must be at least 18 years old to use this website. You agree to use the website only for lawful 
                  purposes and in a way that does not infringe the rights of others or restrict their use of the website.
                </p>
                <p className="leading-relaxed">
                  You are prohibited from using the website to transmit any material that is defamatory, offensive, or 
                  otherwise objectionable, or that violates any applicable laws or regulations.
                </p>
              </section>

              <section className="bg-dark-800 rounded-xl p-6 border border-gray-700">
                <h2 className="text-2xl font-bold text-white mb-4">3. Casino Reviews and Information</h2>
                <p className="leading-relaxed mb-4">
                  The information provided on SpinEmerge.com is for general informational purposes only. While we strive 
                  to provide accurate and up-to-date information, we make no warranties or representations about the 
                  accuracy, completeness, or reliability of any information on the website.
                </p>
                <p className="leading-relaxed">
                  Casino bonuses, terms, and conditions are subject to change by the casinos themselves. We recommend 
                  that you verify all information directly with the casino before making any deposits or claims.
                </p>
              </section>

              <section className="bg-dark-800 rounded-xl p-6 border border-gray-700">
                <h2 className="text-2xl font-bold text-white mb-4">4. Affiliate Relationships</h2>
                <p className="leading-relaxed">
                  SpinEmerge.com may receive compensation from casinos when users click on links or sign up through our 
                  website. This does not affect our editorial independence or the accuracy of our reviews. We are 
                  committed to providing honest, unbiased information regardless of affiliate relationships.
                </p>
              </section>

              <section className="bg-dark-800 rounded-xl p-6 border border-gray-700">
                <h2 className="text-2xl font-bold text-white mb-4">5. Responsible Gambling</h2>
                <p className="leading-relaxed mb-4">
                  We promote responsible gambling and encourage all users to gamble responsibly. If you feel you may have 
                  a gambling problem, please seek help from organizations such as GambleAware or GamCare.
                </p>
                <p className="leading-relaxed">
                  We are not responsible for any losses incurred as a result of gambling. Gambling should be treated as 
                  entertainment, not as a way to make money.
                </p>
              </section>

              <section className="bg-dark-800 rounded-xl p-6 border border-gray-700">
                <h2 className="text-2xl font-bold text-white mb-4">6. Intellectual Property</h2>
                <p className="leading-relaxed">
                  All content on SpinEmerge.com, including text, graphics, logos, and images, is the property of 
                  SpinEmerge or its content suppliers and is protected by copyright and other intellectual property laws. 
                  You may not reproduce, distribute, or create derivative works from any content without our express 
                  written permission.
                </p>
              </section>

              <section className="bg-dark-800 rounded-xl p-6 border border-gray-700">
                <h2 className="text-2xl font-bold text-white mb-4">7. Limitation of Liability</h2>
                <p className="leading-relaxed">
                  SpinEmerge.com shall not be liable for any direct, indirect, incidental, special, or consequential 
                  damages resulting from your use of the website or any information contained therein. This includes, 
                  but is not limited to, losses incurred from gambling activities.
                </p>
              </section>

              <section className="bg-dark-800 rounded-xl p-6 border border-gray-700">
                <h2 className="text-2xl font-bold text-white mb-4">8. Changes to Terms</h2>
                <p className="leading-relaxed">
                  We reserve the right to modify these Terms and Conditions at any time. Changes will be posted on this 
                  page with an updated revision date. Your continued use of the website after changes are posted 
                  constitutes acceptance of the modified terms.
                </p>
              </section>

              <section className="bg-dark-800 rounded-xl p-6 border border-gray-700">
                <h2 className="text-2xl font-bold text-white mb-4">9. Contact Information</h2>
                <p className="leading-relaxed">
                  If you have any questions about these Terms and Conditions, please contact us at info@spinemerge.com.
                </p>
              </section>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

